import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
	cloneSettingsRole,
	deleteSettingsRole,
	getSettingsRoles,
} from '../../../../../../services/settings/users';
import { useSearchParams } from 'react-router-dom';

export default function UseRoles() {
	const [searchParams, setSearchParams] = useSearchParams();
	const [selectedRoleId, setSelectedRoleId] = useState('');
	const [createRole, setCreateRole] = useState(false);
	const [rolesList, setRolesList] = useState([]);
	const [loader, setLoder] = useState(false);
	const [sortDirection, setSortDirection] = useState(false);
	const [params, setParams] = useState({
		page: Number(searchParams.get("page")) || 1,
		pageSize: Number(searchParams.get("pageSize")) || 10000,
		orderBy: searchParams.get("orderBy") || "",
		sortBy: searchParams.get("sortBy") || "",
	});
	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.order_by,
			sortBy: newDirection,
		}));
	};
	const handleDeleteRole = async (id) => {
		try {
			const res = await deleteSettingsRole(id);
			if (res.success) {
				toast.success(res.message);
				getRolesList();
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message || 'something went wrong!');
		}
	};
	const handleCloneRole = async (roleId) => {
		try {
			var body = {
				id: roleId,
			};
			const res = await cloneSettingsRole(body);
			if (res.success) {
				toast.success(res.message);
				getRolesList();
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message || 'something went wrong!');
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.id,
				role_name: ele.name,
				description: ele.description,
				action: JSON.stringify({
					id: ele.id,
				}),
			};
		});
	}

	const getRolesList = async () => {
		try {
			setLoder(true);
			const { roles } = await getSettingsRoles(params);
			const data = mappedTableData(roles);
			setRolesList(data);
		} catch (error) {
		} finally {
			setLoder(false);
		}
	};

	const setFilterFromUrl = () => {
		setSortDirection({
			[searchParams.get("orderBy")]: searchParams.get("sortBy") || "",
		});
		if(searchParams.get('type') === 'create-role'){
			setCreateRole(true);
		}else if(searchParams.get('type') === 'edit-role'){
			setSelectedRoleId(searchParams.get('roleId'));
		}
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		if(!createRole){
			url.set("page", params.page);
			url.set("pageSize", params.pageSize);
			url.set("orderBy",params.orderBy);
			url.set("sortBy",params.sortBy);
		}else{
			if(selectedRoleId === ''){
				url.set('type','create-role');
			}else if(selectedRoleId){
				url.set('type','edit-role');
				url.set('roleId',selectedRoleId);
			}
		}
		setSearchParams(url);
	}

	useEffect(() => {
		setUrlSearchParams()
	}, [params, createRole]);


	useEffect(() => {
		if(!createRole){
			getRolesList();
		}
	}, [searchParams]);
	return {
		getRolesList,
		rolesList,
		sortDataList,
		sortDirection,
		loader,
		handleCloneRole,
		handleDeleteRole,
		setCreateRole,
		createRole,
		setSelectedRoleId,
		selectedRoleId,
	};
}
